import React from "react";

// Windows browsers don't render flag emoji (they show "EG", "DE", ...), so country flags are drawn as images.
// Accepts a 2-letter ISO code or flag emoji (one or several, e.g. a Brazil + Mexico team). Anything else
// (custom emoji, "ROW", ...) is rendered as plain text.
const REGIONAL_A = 0x1f1e6;
const REGIONAL_Z = 0x1f1ff;

export function flagCodes(flag: string): string[] | null {
  const value = (flag || "").trim();
  if (/^[a-zA-Z]{2}$/.test(value)) return [value.toLowerCase()];

  const letters: string[] = [];
  for (const ch of Array.from(value)) {
    const cp = ch.codePointAt(0)!;
    if (cp >= REGIONAL_A && cp <= REGIONAL_Z) letters.push(String.fromCharCode(97 + cp - REGIONAL_A));
  }
  if (letters.length < 2) return null;
  const codes: string[] = [];
  for (let i = 0; i + 1 < letters.length; i += 2) codes.push(letters[i] + letters[i + 1]);
  return codes;
}

// Non-country teams: "ROW"/"WORLD" show a globe, "ASIA" shows a dragon.
const GLOBES: Record<string, string> = { ROW: "🌍", WORLD: "🌍", ASIA: "🐉" };

const FlagIcon: React.FC<{ flag: string }> = ({ flag }) => {
  const globe = GLOBES[(flag || "").trim().toUpperCase()];
  if (globe) return <span style={{ fontFamily: '"Segoe UI Emoji","Apple Color Emoji","Noto Color Emoji",sans-serif' }}>{globe}</span>;
  const codes = flagCodes(flag);
  if (!codes) return <>{flag}</>;
  return (
    <span style={{ display: "inline-flex", gap: "0.15em", verticalAlign: "-0.1em" }}>
      {codes.map((code, i) => (
        <img
          key={`${code}-${i}`}
          src={`https://flagcdn.com/w160/${code}.png`}
          alt={code.toUpperCase()}
          loading="eager"
          style={{ height: "0.85em", width: "auto", borderRadius: "0.1em", boxShadow: "0 0 0 1px rgba(0,0,0,.25)" }}
        />
      ))}
    </span>
  );
};

export default FlagIcon;
